import { FormattersTypes } from '@/services/types/formatter'


export default ({ vtag, data }: FormattersTypes) => {

  let reportsProfitRed = false;
  let reportsProfitGreen = false;
  let reportsProfitGray = false;

  if (data['reports-profit'] < 0) {
    reportsProfitRed = true
  } else if (data['reports-profit'] > 0) {
    reportsProfitGreen = true
  } else (reportsProfitRed = false, reportsProfitGreen = false, reportsProfitGray = true);


  let icons = [vtag('p', {
    class: {
      'profit': true,
      'success': reportsProfitGreen,
      'danger': reportsProfitRed,
      'gray': reportsProfitGray,
    }
  }, [''])];

  return icons

}